import Form from "../../components/Form";

export default function Financial() {
    return <Form type={"financial"}/>;
}
